/*
 * @Author: your name
 * @Date: 2022-01-28 11:02:29
 * @LastEditTime: 2024-08-09 10:44:17
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\filterField\BsyFilterBase\index.jsx
 */

import React from 'react'
import { BsyUtils } from '../../../utils/Utils';
import BsySelect from '../../BsySelect';

import { BsyWidget } from '../../BsyWidget';
import './index.css'
import { BsyConfig } from '../../../global/BsyConfig';

export default class BsyFilterBase extends BsyWidget {

  constructor(props) {
    super({
      baseCls: "fui_dash_filter_base",
      onStopEdit: null,
      method: null,
      changeMethod: !0,
      displayType: {
        list: "checklist",
        box: "xcombocheck"
      },
      showLabel: !0,
      ...props
    });

    this.value = this.options.defaultConfig;
    this.method = this.options.method || this._getDefaultMethod();
    this.valueMode = this.options.valueMode
    this.relyFilter = this.options.relyFilter

  }

  //由于React数据 驱动机制
  getMiddleValue = () => {
    return this.value
  }

  setDefaultConfig = () => {
    this.value = this.options.defaultConfig;
    this.method = this.options.method;
    this.setState({})
  }

  setValue = (t, method) => {
    this.value = t || {};
    if (method)
      this.method = method || this.options.method;
    this.setState({})
  }
  clearValue = (t, method)=>{ 
    let _this = this
    _this.method = _this.options.method;
    this.setState({})
    setTimeout(() => {//此组件清空有bug，后续有时间再看逻辑
      this.setState({})
    }, 20);
  }
  createTitleBar = () => {
    const { changeMethod, valueMode } = this.options;
    return (
      <div className={"bsy-dash-head " + valueMode}>
        <div className="bsy-cond-label" >
          {this.options.title}
        </div>
        {
          changeMethod ? <BsySelect
            theme={this.props.theme}
            allowBlank={false}
            searchable={false}
            customCls={'cond-method'}
            onStopEdit={this.changeMethod}
            value={this.method}
            items={this._getMethodItems()}
          /> : ''
        }
      </div>)
  }

  changeMethod = (t, a) => {
    let e = this
      , i = this.options
    if (t !== e.method) {
      e.method = t
      this.value = {};
      // e._createValCell();
      this.setState({}, () => {
        BsyUtils.applyFunc(e, i.onStopEdit, [{
          value: null,
          method: e.method,
          valueMode: e.valueMode
        }, i], !1)
        BsyUtils.applyFunc(e, i.onMethodChange, [e.method], !1)
      })
    }

  }

  _getDefaultMethod = () => {
    var t = this.options;
    return BsyUtils.getDashDefaultFilterMethod(t.fields[0] && t.fields[0].type) || this._getAvailableMethods()[0]
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {

    if (!BsyUtils.compare(this.options.defaultConfig, nextProps.defaultConfig)) {
      this.options.defaultConfig = { ...nextProps.defaultConfig };
      this.setState({})
    }
  }

  _getMethodItems = () => {
    var t = this
      , e = [];
    BsyUtils.forEach(this._getAvailableMethods(), function (i, a) {
      e.push({
        text: t._getMethodName(a),
        value: a
      })
    })
    return e
  }
  _getAvailableMethods = () => {
    return []
  }
  _getMethodName = (t) => {
    var e = {};
    e[BsyConfig().CONST.FILTER_METHOD.EQ] = {
      name: React.language("filter.method.eq")
    }
    e[BsyConfig().CONST.FILTER_METHOD.NE] = {
      name: React.language("filter.method.ne")
    }
    e[BsyConfig().CONST.FILTER_METHOD.ALL] = {
      name: React.language("filter.method.all")
    }
    e[BsyConfig().CONST.FILTER_METHOD.IN] = {
      name: this._isMultiValField() ? React.language("filter.method.in.many") : React.language("filter.method.in.one")
    }
    e[BsyConfig().CONST.FILTER_METHOD.NIN] = {
      name: React.language("filter.method.nin")
    }
    e[BsyConfig().CONST.FILTER_METHOD.LK] = {
      name: React.language("filter.method.lk")
    }
    e[BsyConfig().CONST.FILTER_METHOD.ULK] = {
      name: React.language("filter.method.ulk")
    }
    e[BsyConfig().CONST.FILTER_METHOD.EP] = {
      name: React.language("filter.method.ep")
    }
    e[BsyConfig().CONST.FILTER_METHOD.NEP] = {
      name: React.language("filter.method.nep")
    }
    e[BsyConfig().CONST.FILTER_METHOD.GT] = {
      name: React.language("filter.method.gt")
    }
    e[BsyConfig().CONST.FILTER_METHOD.GTE] = {
      name: React.language("filter.method.gte")
    }
    e[BsyConfig().CONST.FILTER_METHOD.LT] = {
      name: React.language("filter.method.lt")
    }
    e[BsyConfig().CONST.FILTER_METHOD.LTE] = {
      name: React.language("filter.method.lte")
    }
    e[BsyConfig().CONST.FILTER_METHOD.RG] = {
      name: React.language("filter.method.rg")
    }
    e[BsyConfig().CONST.FILTER_METHOD.VF] = {
      name: React.language("filter.method.vf")
    }
    e[BsyConfig().CONST.FILTER_METHOD.NVF] = {
      name: React.language("filter.method.nvf")
    }
    e[BsyConfig().CONST.FILTER_METHOD.FM] = {
      name: React.language("filter.method.fm")
    }
    return e[t].name
  }
  _isMultiValField = () => {
    var t = this.options.fields[0];
    return !!t && ["combocheck", "checkboxgroup", "usergroup", "deptgroup"].indexOf(t.type) > -1
  }
  _createValCell = () => {
    // this.$content || (this.$content = window.$('<div class="dash-cont"/>').appendTo(this.element))
    // this.$content.height(this.getDashContentHeight()).empty()
  }
  _initDefaultValue = () => {
    var t = this.options;
    BsyUtils.isObjectEmpty(t.defaultConfig) || this.setValue(t.defaultConfig)
  }
  _getCompType = () => {
    var t = this.options;
    return t.displayType ? t.sizeY > t.minRow ? t.displayType.list : t.displayType.box : null
  }
  _getAsyncConfig = () => {
    let e = this.options;

    if (!e.fields[0])
      return {};
    if (e.sync) {
      return e.sync
    }
    let i, a;
    if (e.flowType !== undefined) {
      if (e.type === "user_filter" || e.type === "usergroup_filter") {
        i = "/manager/team/list"
        a = {
          appId: e.appId,
          hasAdmin: !0,
          hasCurrentUser: false,
          hasDeptRange: true,
          "flowType": e.flowType,
          hasCount: !1
        }
      } else if (e.type === "flowcreator_filter") {
        i = "/data/distinct"
        a = {
          appId: e.appId,
          "flowType": e.flowType,
          formId: e.entryId
        }
      } else if (e.type === "flownode_filter" || e.type === "backflowid_filter") {
        i = `/dashboard/app/${e.appId}/workflow/query_node`
        a = {
          appId: e.appId,
          "flowType": e.flowType,
          formId: e.entryId
        }
      } else {
        i = "/data/distinct";
        a = {
          "entryId": e.entryId,
          "formId": e.entryId,
          "field": e.widgetId,
          "type": e.type,
          "flowType": e.flowType,
          "appId": e.appId
        }
      }
    } else {
      i = "/data/filter_widget_distinct"

      if(     "visit" === e.mode) {
        a = {
          widgetId: e.widgetId,
          appId: e.appId,
          entryId: e.entryId,
        }
      } else {
        a = {
          widget: window.$.extend({}, e.componentAttr, {
            fields: e.fields,
            defaultConfig: e.defaultConfig,
            method: e.method,
            reportType: "dash",
            valueMode: e.valueMode,
            title: e.title,
            appId: window.FX.STATIC.APPID, // 数据加载的时候，弹出表单的APPID
            entryId: window.GLOBALENTRYID, // 数据加载的时候，url上表单的ENTRYID
          })
        }
      }

      // "visit" === e.mode ? (
      //   a = {
      //     widgetId: e.widgetId,
      //     appId: e.appId,
      //     entryId: e.entryId,
      //   }) : (
      //   a = {
      //     widget: window.$.extend({}, e.componentAttr, {
      //       fields: e.fields,
      //       defaultConfig: e.defaultConfig,
      //       method: e.method,
      //       reportType: "dash",
      //       valueMode: e.valueMode,
      //       title: e.title,
      //       appId: window.FX.STATIC.APPID, // 数据加载的时候，弹出表单的APPID
      //       entryId: window.GLOBALENTRYID, // 数据加载的时候，url上表单的ENTRYID
      //     })
      //   })
    }
    return {
      url: i,
      data: a
    }
  }
  _formatComboValue = (t, e) => {
    var i = this.options;
    e = e || "value"
    t && t.items || (t = {
      hasEmpty: !1,
      items: t ? [t.value] : []
    })
    if ("checklist" === this._getCompType()) {
      var a = t.items.slice(0);
      t.hasEmpty && a.push(i.customItem[e])
      return a
    }
    return t
  }
  getEditConfig = () => {
    var t = this.options;
    return {
      fields: t.fields,
      triggers: t.triggers,
      method: t.method,
      valueMode: t.valueMode,
      defaultConfig: this.getValue()
    }
  }
  doResize = (t) => {
    // var e = this.options;
    // window.FX.DashFilterBase.superclass.doResize.apply(this, arguments),
    //   t && "edit" === e.mode && (e.sizeX = t.sizeX,
    //     e.sizeY = t.sizeY,
    //     this._createValCell(),
    //     this._initDefaultValue())
  }
  getDashContentHeight = () => {
    var e = this.options
      , i = window.$(".dash-head", this.element);
    return e.height - i.height() - 10
  }
  rebuild = (t) => {
    var e = this.options;
    e.defaultConfig = t.defaultConfig
    e.fields = t.fields
    e.method = t.method
    e.valueMode = t.valueMode
    // window.FX.DashFilterBase.superclass.rebuild.apply(this, arguments)
  }
  getValueMode = () => {
    return this.options.valueMode
  }
  getMethod = () => {
    return this.options.method
  }
  setValueMode = (t) => {
    this.options.valueMode = t
    this.options.method = this._getDefaultMethod();
    // if(t != "input")
    // {
    //
    // }
    this._createMethod();
    this._createValCell();
    this.setValue(null)
  }

}
